<section id="wrapper" class="error-page">
  <div class="error-box">
    <div class="error-body text-center">
      <img
        class="error"
        src="../../../assets/images/images/error404.png"
        alt="Error 404"
      />
      <h3 class="text-uppercase">
        {{ 'NOPAGEFOUND.DESCRIPTION' | transloco }}
      </h3>
      <a
        routerLink="/sign-in"
        class="btn btn-danger btn-no-page-found btn-rounded waves-effect waves-light m-b-40"
        >{{ 'NOPAGEFOUND.BUTTON' | transloco }}</a
      >
    </div>
    <footer class="footer text-center">© {{ year }} Lab4u</footer>
  </div>
</section>
